import moment from "moment";

export function checkingFilter(
  pageValue,
  formInput,
  sortingField,
  field,
  token,
  isActive
) {
  let sort = [];
  sortingField.map((item) => {
    if (item.sorting === "asc") {
      sort.push(`${item.field}`);
    } else {
      sort.push(`-${item.field}`);
    }
    return "";
  });

  let body = {};
  if (formInput[field]) {
    body = {
      [field]: {
        $regex: formInput[field],
        $options: "i",
      },
    };
  }

  if (formInput.from) {
    if (formInput.to) {
      body = {
        ...body,
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to)
            .add(23, "hours")
            .add(59, "minutes")
            .format(),
        },
      };
    } else {
      body = {
        ...body,
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to)
            .add(23, "hours")
            .add(59, "minutes")
            .format(),
        },
      };
    }
  }

  let filterData = {
    token: token,
    body: {
      ...body,
      isActive: isActive,
    },
    params: {
      page: pageValue,
      limit: formInput.limit > 0 ? formInput.limit : 10,
      paginate: true,
      sort: sort.toString().replaceAll(",", " "),
    },
  };
  return filterData;
}
